/**
 * curatedReviews.js — Hand-picked "greatest hits" customer quotes.
 *
 * These are guaranteed to render even when the Google Places API has zero
 * results (cold start, network outage, etc.). They also appear in a small
 * "Reseñas destacadas" strip in the Home, just before the live Google block,
 * so the page always opens with a strong social-proof anchor.
 *
 * Editable rules:
 *  - Each entry needs `author` + `text`. `source`, `rating` and `relative_time`
 *    are optional and only used for the small line beneath the quote.
 *  - Keep texts at ~200-380 characters for visual balance.
 *  - Move the entries you want to feature to the top of the array.
 *
 * Roadmap: when the owner wants to edit these from the CRM we can move them
 * into a `curated_reviews` MongoDB collection with the same Pydantic model.
 */
export const CURATED_REVIEWS = [
    {
        author: "Carmen R.",
        rating: 5,
        relative_time: "Comida familiar de domingo",
        source: "Google",
        text:
            "Vinimos desde Madrid sin saber muy bien qué esperar y nos hemos enamorado del sitio. El chuletón a la brasa de encina es de otro nivel y el patio interior con el artesonado original te transporta cinco siglos atrás. Volveremos seguro.",
    },
    {
        author: "Javier M.",
        rating: 5,
        relative_time: "Aniversario",
        source: "TripAdvisor",
        text:
            "Cenamos para celebrar nuestro aniversario y fue una experiencia redonda: producto impecable, vinos manchegos muy bien escogidos y un trato cercano. Después de comer nos enseñaron el museo de los guantes de perrillo, una joya escondida.",
    },
    {
        author: "Lucía P.",
        rating: 5,
        relative_time: "Reunión de empresa",
        source: "Google",
        text:
            "Organicé una comida de empresa con 24 personas y todo fue perfecto: menú a medida, salón privado y la visita guiada al museo encantó a mis compañeros. Comunicación con el equipo fluida desde el primer momento.",
    },
    {
        author: "Familia Sánchez",
        rating: 5,
        relative_time: "Boda íntima",
        source: "Reseña directa",
        text:
            "Quisimos una boda pequeña y diferente y aquí encontramos justo eso: un edificio del siglo XV con alma, cocina manchega de verdad y un equipo que se vuelca contigo. Nuestros invitados aún hablan del cordero y del chuletón.",
    },
    {
        author: "Marta y Antonio",
        rating: 5,
        relative_time: "Escapada a Ocaña",
        source: "TripAdvisor",
        text:
            "Estábamos haciendo la ruta por la judería y la Plaza Mayor y entramos sin reserva. Acertamos al 100%. Cocina tradicional, presentada con cuidado, y la dueña nos contó la historia de la tenería como si fuera una novela.",
    },
];
